import React from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import toast from 'react-hot-toast';

import Button from '../../components/ui/Button';
import InputField from '../../components/ui/InputField';
import AuthLayout from '../../layout/AuthLayout';
import {useNavigate} from 'react-router-dom';
import {pageRoutes} from '../../routes';
import useAuthStore from '../../store/useAuthStore';
import {useLogin} from '../../api/auth';

const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter valid email')
    .required('Email is required'),
  password: yup.string().required('Password is required'),
});

const Login = () => {
  const navigate = useNavigate();
  const updateAuthDetail = useAuthStore((state) => state.updateAuthDetails);

  const loginMutation = useLogin();
  const {isLoading} = loginMutation;

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'all',
  });

  const handleLoginSuccess = ({data}) => {
    const {token, ...userDetails} = data;

    updateAuthDetail({
      token: token,
      user: userDetails,
      isLogin: true,
    });
    reset();
    toast.success('Login Successful');
    navigate('/');
  };

  const handleFormSubmission = async (values) => {
    const loginPayload = {
      ...values,
      role: 'admin',
    };

    loginMutation.mutate(loginPayload, {
      onSuccess: handleLoginSuccess,
      onError: (data) => toast.error(data.response.data.message),
    });
  };

  return (
    <>
      <h2 className="text-primary-main text-3xl font-bold ">Login</h2>
      <form
        className="mt-10 mb-7"
        onSubmit={handleSubmit(handleFormSubmission)}
      >
        <div className="flex items-center mb-7">
          <InputField
            {...register('email')}
            placeholder="email"
            error={errors?.email?.message}
            fullWidth
          />
        </div>
        <div className="flex items-center">
          <InputField
            type="password"
            {...register('password')}
            placeholder="password"
            error={errors?.password?.message}
            fullWidth
          />
        </div>
        <Button
          variant="flat"
          className="block ml-auto text-sm my-2"
          onClick={() => navigate(pageRoutes.forgotPassword)}
        >
          Forgot Password ?
        </Button>
        <Button className="block " type="submit" loading={isLoading}>
          Continue
        </Button>
      </form>
    </>
  );
};

export default AuthLayout(Login);
